import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Music from '../components/Music';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <div className="bg-black">
      <Navbar />
      <Hero />
      <About />
      <Music />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
